import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { Router } from '@angular/router';
import { environment } from '@src/environments/environment';
import Utils from '@src/app/helpers/Utils';


@Component({
    selector: 'app-trainingfiles',
    templateUrl: './trainingfiles.component.html',
    styleUrls: ['./trainingfiles.component.scss'],
    standalone: false
})
export class TrainingFilesComponent implements OnInit, AfterViewInit {

  isDisabled = true;
  pagesCount: number;
  fileUrl: string;
  currentPage = 1;
  constructor(
    private router: Router
  ) { }
  ngAfterViewInit(): void {
    if (environment.environmentName === 'test' && !!sessionStorage.getItem(environment.sessionIsYMUser)) {
      setTimeout(() => 
      {
        this.router.navigate(['/exam']);
      },
      3000);
    }
  }

  ngOnInit() {
    const bookType = Utils.getBookType();
    const fileName = sessionStorage.getItem(environment.sessionSelectedTrainingFile);
    const lang = sessionStorage.getItem(environment.sessionLang).toUpperCase();
    //'assets/trainings/KBK_DE51.pdf'
    this.fileUrl = `assets/trainings/${bookType.toUpperCase()}_${lang.substring(0, 2)}${fileName}.pdf`;
  }

  onPagesLoaded(ev) {
    //console.log(ev);
    this.pagesCount = ev.pagesCount;
    if(this.pagesCount === 1){
      this.isDisabled = false;
    }
  }
  onPageChange(pageNr) {
    if (pageNr >= this.pagesCount) {
      this.isDisabled = false;
    }
  }
  onClick() {
    if(sessionStorage.getItem(environment.sessionIsYMUser)){
      this.router.navigate(['/exam']);
      return;
    }
    this.router.navigate(['/userdata']);
  }

}
